import sanitizeFilename from 'sanitize-filename'

export const extractDownloadHeaders = (headers: Headers) => {
  const rawFileName = headers.get('content-disposition') ?? 'Untitled'
  const contentType = headers.get('content-type') ?? 'text/plain'
  const fileName = sanitizeFilename(
    decodeURI(rawFileName.replace('Attachment;filename=', '')),
  )

  return { fileName, contentType }
}
